module.exports = __webpack_public_path__ + "img/hdc_01.37b62750.png";